import React, {Component} from 'react';
import {getFormFieldsByUserId, getFetchUrlParams, getAllTeam} from '../../util/APIUtils';
import {SESSION_USER,API_BASE_URL,SSO_PARAMS} from '../../constants';
import Loading from '../../common/Loading';
import NotFound from '../../common/NotFound';

import Calendar from './Calendar';
import External from './External';
import ServerError from '../../common/ServerError';
//import UnScheduleJobForm from './UnScheduleJobForm';

class Schedule extends Component {

    constructor(props) {
        super(props);
        this.state = {
            resources:[],
            fields:[],
            nowdatetime:'',
            currenttime:'',
            loading: true,
            scheduleloading: true,
            ssoparams:'',
            fieldsloading:true,
            calendarview:'timelineDay',
            travelEventBgColor:'#54555e',
            teamsResponse:[],
        };
            
    }



    componentDidMount() {
   
   var params2 = getFetchUrlParams(this.props.location.search);
  // console.log(params2);
   if(params2.view){
          this.setState({calendarview:params2.view});
   }

   
                let user = JSON.parse(localStorage.getItem(SESSION_USER));
                if(user.setting){
                     this.setState({travelEventBgColor:user.setting.travelEventBgColor});
                }

                var peopleObject=[];
        
                getFormFieldsByUserId(user.id).then(response => {
                     //   console.log(response);
                       if(response){ 
                        //console.log(response);
                             if(response.peoples){//here get all resouses in
                                   for(var k in response.peoples){
                                       var people=response.peoples[k];
                                       
                                      
                                       var image_url='../static/assets/images/people.png';
                                       if(people.profileLogo){
                                         image_url=API_BASE_URL+'/image/people/'+people.id+'/profileimage.jpg';
                                       }
                                     //  var businessHours={start:people.workingfromtime,end:people.workingtotime};
                                       
                                       var resource={
                                            id:people.id,
                                            title:people.firstName+' '+people.lastName,
                                            eventBackgroundColor:people.bgcolor,
                                            eventBorderColor:people.bgcolor,
                                            eventTextColor:people.textcolor,
                                            image_url:image_url,
                                            businessHours:people.businessHours

                                       };
                                       peopleObject.push(resource);
                                   }
                                   this.setState({resources:peopleObject});
                            }
                            if(response.nowDateTime){
                              this.setState({nowdatetime:response.nowDateTime});
                            }
                             if(response.currentTime){
                              this.setState({currenttime:response.currentTime});
                            }
                            if(response.unschedules){
                                   this.setState({unschedule:response.unschedules});
                            }
                            if(response.schedules){
                                   this.setState({schedules:response.schedules});
                            }
                            this.setState({fields:response,fieldsloading: false});
                        }     
                      
                }).catch(error => {
                   if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });        
                    }
                });
         
         
                let params =  JSON.parse(localStorage.getItem(SSO_PARAMS));
                //console.log(params);
                if(params){
                        this.setState({ssoparams:params});
                }

                getAllTeam(user.id)
                    .then(response => {
                        console.log(response);
                        this.setState({teamsResponse:response});
                    }).catch(error => {
                    if(error.status === 404) {
                        this.setState({
                            notFound: true,
                        });
                    } else {
                        this.setState({
                            serverError: true,
                        });
                    }
                });

    }

//<UnScheduleJobForm ssoparams={this.state.ssoparams}/>
    render(){

         if(this.state.notFound) {
            return <NotFound />;
        }

        if(this.state.serverError) {
            return <ServerError />;
        }

        if(this.state.fieldsloading) {
           return <Loading />;
        } 

    return (


                <div className="row">
                     
                    <External unschedule={this.state.unschedule}  />
                    <Calendar calendarview={this.state.calendarview} currenttime={this.state.currenttime} nowdatetime ={this.state.nowdatetime} schedules={this.state.schedules} travelEventBgColor={this.state.travelEventBgColor} resources={this.state.resources} fields={this.state.fields} teamsResponse={this.state.teamsResponse} />
                </div>


          );
  } 
}
export default Schedule;
